import { STORES } from "stores";

export const hydrateStores = async () => {
  await Promise.all(
    Object.entries(STORES).map(async ([, store]) => {
      if (!store?.afterHydration) return;
      await store.afterHydration();
    })
  );
};
